/**
 * Recherche par défaut de `/bundles` : la route a des paramètres à valeur par
 * défaut, donc TanStack Router exige l'objet complet sur chaque `<Link>` /
 * `navigate` qui y revient.
 */
export const BUNDLES_LIST_SEARCH = { page: 1, pageSize: 50, sortDir: 'desc' } as const;

export interface BundleFiltersValue {
  search?: string;
  enabled?: boolean;
}

export type BundleFiltersPatch = Partial<{ search: string | undefined; enabled: boolean | undefined }>;

function readRecord(value: unknown): Record<string, unknown> {
  return typeof value === 'object' && value !== null ? (value as Record<string, unknown>) : {};
}

/** Lit les filtres de l'écran Bundles depuis `useSearch({strict:false})` (`02` §8). */
export function readBundleFilters(rawSearch: unknown): BundleFiltersValue {
  const search = readRecord(rawSearch);
  return {
    ...(typeof search.search === 'string' ? { search: search.search } : {}),
    ...(typeof search.enabled === 'boolean' ? { enabled: search.enabled } : {}),
  };
}
